import { gql, useLazyQuery } from "@apollo/client";
import { useCallback, useEffect, useRef } from "react";

const GET_BEFORE_AND_AFTER_PROJECT = gql`
  query GetBeforeAndAfterProject($projectId: ID!) {
    getBeforeAndAfterProject(projectId: $projectId) {
      _id
      designerId {
        _id
        firstName
        lastName
        businessCity
        businessState
      }
      afterImage {
        url
        path
        name
        _id
        title
        description
      }
      beforeImage {
        _id
        name
        path
        url
        title
        description
      }
      coverImage {
        _id
        url
        name
        path
        title
        credit
        description
      }
      beforeImages {
        _id
        url
        name
        path
        title
        credit
        description
      }
      afterImages {
        _id
        url
        name
        path
        title
        credit
        description
      }
      budgetRange
      description
      name
      projectCategory
      projectDuration
      specialRequirements
      squareFootage
      style
      published
      storyTitle
      storySubtitle
      introduction
      challenges
      wishList
      overview
      additionalSections {
        title
        content
      }
    }
  }
`;

export const useGetBeforeAndAfterProjectQuery = () => {
  const [getBeforeAndAfterProjectQuery, { loading, data }] = useLazyQuery(
    GET_BEFORE_AND_AFTER_PROJECT
  );

  const queryFnRef = useRef(getBeforeAndAfterProjectQuery);

  // Keep the latest lazy query function without changing the public API reference.
  useEffect(() => {
    queryFnRef.current = getBeforeAndAfterProjectQuery;
  }, [getBeforeAndAfterProjectQuery]);

  const getBeforeAndAfterProject = useCallback(
    async (projectId: string, refresh: boolean = false) => {
      const result = await queryFnRef.current({
        variables: {
          projectId,
        },
        fetchPolicy: refresh ? "network-only" : "cache-first",
      });
      return result?.data?.getBeforeAndAfterProject;
    },
    []
  );

  const beforeAndAfterProject = data?.getBeforeAndAfterProject;

  return {
    getBeforeAndAfterProject,
    loading,
    beforeAndAfterProject,
  };
};
